import { Chip, Stack } from '@mui/joy';
import { Info } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'core/elements';
import { ExternalProjectAssociationType } from 'projects/enums';
import { Color, Variant } from 'theme/enums';

import { getPairedProjectValues, IExternalCustomerRow } from './utils';

const getColor = (type: ExternalProjectAssociationType) => {
  switch (type) {
    case ExternalProjectAssociationType.BILL_TO_ACCOUNT:
      return Color.SUCCESS;
    case ExternalProjectAssociationType.SHIP_TO_ACCOUNT:
      return Color.PRIMARY;
    default:
      return Color.NEUTRAL;
  }
};

export const AssociationTypeCell = ({ data, value }: ICellRendererParams<IExternalCustomerRow>) => {
  const { t } = useTranslation();

  const types: ExternalProjectAssociationType[] = value ?? [];

  if (!data?.isViaProject) {
    return (
      <Stack>
        {types.map((type) => (
          <Chip key={type} color={getColor(type)}>
            {type}
          </Chip>
        ))}
      </Stack>
    );
  }

  const projectNumbers = getPairedProjectValues(data, 'projectNumber');

  const tooltipTitle = t('tooltipAccountViaProject', {
    count: projectNumbers.length,
    projectNumbers: projectNumbers.join(', '),
  });

  return (
    <Stack>
      {types.map((type) => (
        <Chip
          key={type}
          color={getColor(type)}
          variant={Variant.OUTLINED}
          endDecorator={
            <Tooltip title={tooltipTitle} childrenSx={{ cursor: 'default' }}>
              <Info data-testid="via-project-info" />
            </Tooltip>
          }
        >
          {t('labelAssociationTypeViaProject', { type })}
        </Chip>
      ))}
    </Stack>
  );
};
